import React from "react";

import SupportingText from "../SupportingText";
import LeadingText from "../LeadingText";

function Impressum() {
  return (
    <div className="w-full py-2">
      <div className="py-2">
        <LeadingText textColor="black">Firmensitz / Adresse</LeadingText>
      </div>
      <SupportingText textColor="black">Libuda Optik e.K.</SupportingText>
      <SupportingText textColor="black">
        Inh. Georg Günter Libuda Optik Großhandel
      </SupportingText>
      <SupportingText textColor="black">Heinrich-Hertz-Str. 27</SupportingText>
      <SupportingText textColor="black">
        78052 Villingen-Schwenningen
      </SupportingText>
      <SupportingText textColor="black">
        Telefon: + 49 (0) 77 21 / 99 40 - 200
      </SupportingText>
      <SupportingText textColor="black">
        Telefax: + 49 (0) 77 21 / 99 40 - 222
      </SupportingText>
      <br />
      <SupportingText textColor="black">info@libuda-optik.de </SupportingText>
      <SupportingText textColor="black">www.libuda-optik.de</SupportingText>
      <br />
      <SupportingText textColor="black">
        Gerichtsstand: Villingen-Schwenningen
      </SupportingText>
      <SupportingText textColor="black">
        Umsatzsteuer-ID: DE 143022772
      </SupportingText>
      <SupportingText textColor="black">
        Handelsregisterblatt 2542
      </SupportingText>
      <SupportingText textColor="black">
        Inhaber: Georg G. Libuda
      </SupportingText>
      <br />
      <div className="py-2">
        <LeadingText textColor="black">Haftungsausschluss</LeadingText>
      </div>
      <SupportingText textColor="black">
        1. Inhalt des Onlineangebots
      </SupportingText>
      <div className="py-2">
        <SupportingText textColor="black">
          Der Autor übernimmt keinerlei Gewähr für die Aktualität, Korrektheit,
          Vollständigkeit oder Qualität der bereitgestellten Informationen.
          Haftungsansprüche gegen den Autor, welche sich auf Schäden materieller
          oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung
          der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und
          unvollständiger Informationen verursacht wurden, sind grundsätzlich
          ausgeschlossen, sofern seitens des Autors kein nachweislich
          vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle
          Angebote sind freibleibend und unverbindlich. Der Autor behält es sich
          ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne
          gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die
          Veröffentlichung zeitweise oder endgültig einzustellen.
        </SupportingText>
      </div>
      <SupportingText textColor="black">2. Verweise und Links</SupportingText>
      <div className="py-2">
        <SupportingText textColor="black">
          Bei direkten oder indirekten Verweisen auf fremde Internetseiten
          ("Links"), die außerhalb des Verantwortungsbereiches des Autors
          liegen, würde eine Haftungsverpflichtung ausschließlich in dem Fall in
          Kraft treten, in dem der Autor von den Inhalten Kenntnis hat und es
          ihm technisch möglich und zumutbar wäre, die Nutzung im Falle
          rechtswidriger Inhalte zu verhindern. Der Autor erklärt hiermit
          ausdrücklich, dass zum Zeitpunkt der Linksetzung keine illegalen
          Inhalte auf den zu verlinkenden Seiten erkennbar waren. Auf die
          aktuelle und zukünftige Gestaltung, die Inhalte oder die Urheberschaft
          der gelinkten/verknüpften Seiten hat der Autor keinerlei Einfluss.
          Deshalb distanziert er sich hiermit ausdrücklich von allen Inhalten
          aller gelinkten /verknüpften Seiten, die nach der Linksetzung
          verändert wurden. Diese Feststellung gilt für alle innerhalb des
          eigenen Internetangebotes gesetzten Links und Verweise sowie für
          Fremdeinträge in vom Autor eingerichteten Gästebüchern,
          Diskussionsforen und Mailinglisten. Für illegale, fehlerhafte oder
          unvollständige Inhalte und insbesondere für Schäden, die aus der
          Nutzung oder Nichtnutzung solcherart dargebotener Informationen
          entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen
          wurde, nicht derjenige, der über Links auf die jeweilige
          Veröffentlichung lediglich verweist.
        </SupportingText>
      </div>
      <SupportingText textColor="black">
        3. Urheber- und Kennzeichnungsrecht
      </SupportingText>
      <div className="py-2">
        <SupportingText textColor="black">
          Alle innerhalb des Internetangebotes genannten und ggf. durch Dritte
          geschützten Marken- und Warenzeichen unterliegen uneingeschränkt den
          Bestimmungen des jeweils gültigen Kennzeichenrechts und den
          Besitzrechten der jeweiligen eingetragenen Eigentümer. Allein aufgrund
          der bloßen Nennung ist nicht der Schluß zu ziehen, dass Markenzeichen
          nicht durch Rechte Dritter geschützt sind! Das Copyright für
          veröffentlichte, vom Autor selbst erstellte Objekte bleibt allein beim
          Autor der Seiten. Eine Vervielfältigung oder Verwendung solcher
          Grafiken, Tondokumente, Videosequenzen und Texte in anderen
          elektronischen oder gedruckten Publikationen ist ohne ausdrückliche
          Zustimmung des Autors nicht gestattet.
        </SupportingText>
      </div>
      <SupportingText textColor="black">4. Datenschutz</SupportingText>
      <div className="py-2">
        <SupportingText textColor="black">
          Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe
          persönlicher oder geschäftlicher Daten (Emailadressen, Namen,
          Anschriften) besteht, so erfolgt die Preisgabe dieser Daten seitens
          des Nutzers auf ausdrücklich freiwilliger Basis. Die Inanspruchnahme
          und Bezahlung aller angebotenen Dienste ist - soweit technisch möglich
          und zumutbar - auch ohne Angabe solcher Daten bzw. unter Angabe
          anonymisierter Daten oder eines Pseudonyms gestattet.
        </SupportingText>
      </div>
      <SupportingText textColor="black">
        5. Rechtswirksamkeit dieses Haftungsausschlusses
      </SupportingText>
      <div className="py-2">
        <SupportingText textColor="black">
          Dieser Haftungsausschluss ist als Teil des Internetangebotes zu
          betrachten, von dem aus auf diese Seite verwiesen wurde. Sofern Teile
          oder einzelne Formulierungen dieses Textes der geltenden Rechtslage
          nicht, nicht mehr oder nicht vollständig entsprechen sollten, bleiben
          die übrigen Teile des Dokumentes in ihrem Inhalt und ihrer Gültigkeit
          davon unberührt.
        </SupportingText>
      </div>
      <br />
      <div className="py-2">
        <LeadingText textColor="black">Streitbeilegungsverfahren</LeadingText>
      </div>
      <SupportingText textColor="black">
        Die Firma erklärt sich nicht zur Teilnahme an Streitbeilegungsverfahren
        vor Verbraucherschlichtungsstellen im Sinne des § 36 Abs. 1
        Verbraucherstreitbeilegungsgesetz (VSBG) bereit. Davon unberührt ist die
        Möglichkeit der Streitbeilegung durch eine Verbraucherschlichtungsstelle
        im Rahmen einer konkreten Streitigkeit bei Zustimmung beider
        Vertragsparteien (§ 37 VSBG). Plattform der EU zur außergerichtlichen
        Online-Streitbeilegung: http://www.ec.europa.eu/consumers/odr/ Zur
        Vermeidung eines etwaigen Rechtsstreits zwischen uns und unseren Kunden
        besteht folgende Allgemeine Verbraucherschlichtungsstelle des Zentrums
        für Schlichtung e.V., Straßburger Str. 8, 77694 Kehl,
        http://www.verbraucher-schlichter.de/
      </SupportingText>
      <br />
      <div className="py-2">
        <LeadingText textColor="black">
          Datenschutzerklärung für die Nutzung von Google Analytics
        </LeadingText>
      </div>
      <SupportingText textColor="black">
        Diese Website benutzt Google Analytics, einen Webanalysedienst der
        Google Inc. („Google“). Google Analytics verwendet sog. „Cookies“,
        Textdateien, die auf Ihrem Computer gespeichert werden und die eine
        Analyse der Benutzung der Website durch Sie ermöglichen. Die durch den
        Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden
        in der Regel an einen Server von Google in den USA übertragen und dort
        gespeichert. Im Falle der Aktivierung der IP-Anonymisierung auf dieser
        Webseite, wird Ihre IP-Adresse von Google jedoch innerhalb von
        Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten
        des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur
        in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google
        in den USA übertragen und dort gekürzt. Die IP-Anonymisierung ist auf
        dieser Website aktiv. Im Auftrag des Betreibers dieser Website wird
        Google diese Informationen benutzen, um Ihre Nutzung der Website
        auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen
        und um weitere mit der Websitenutzung und der Internetnutzung verbundene
        Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. Die im
        Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse
        wird nicht mit anderen Daten von Google zusammengeführt. Sie können die
        Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
        Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie
        in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website
        vollumfänglich werden nutzen können. Sie können darüber hinaus die
        Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der
        Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die
        Verarbeitung dieser Daten durch Google verhindern, indem sie das unter
        dem folgenden Link verfügbare Browser-Plugin herunterladen und
        installieren: http://tools.google.com/dlpage/gaoptout?hl=de. Alternativ
        zum Browser-Add-On oder innerhalb von Browsern auf mobilen Geräten,
        klicken Sie bitte diesen Link, um die Erfassung durch Google Analytics
        innerhalb dieser Website zukünftig zu verhindern (das Opt Out
        funktioniert nur in dem Browser und nur für diese Domain). Dabei wird
        ein Opt-Out-Cookie auf Ihrem Geät abgelegt. Löschen Sie Ihre Cookies in
        diesem Browser, müssen Sie diesen Link erneut klicken.
      </SupportingText>
    </div>
  );
}

export default Impressum;



// WEBPACK FOOTER //
// ./src/Impressum/Impressum.js